import React, { useCallback, useEffect, useState } from 'react';
import './../Form.scss';
import './ItinerariosForm.scss';
import { useHistory, useParams } from 'react-router';
import service from '../../../services/itinerarios';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faSave } from '@fortawesome/free-solid-svg-icons';
import { hasText } from '../../../utils/utils';

const ItinerariosForm = props => {
    
    const history = useHistory();
    const params = useParams();
    const [itinerario, setItinerario] = useState({});

    const { register, handleSubmit } = useForm();

    const onSubmit = data => {
        save(data);
    };

    const carregarItinerario = useCallback(async (id) => {
        const itinerarioInicial = await service.getById(id);
        setItinerario(itinerarioInicial);
        
    }, []);


    useEffect(() => {
        if (params.id) {
            carregarItinerario(params.id);
        }
    }, [carregarItinerario, params.id]);

    const save = async (data) => {
       
        const res = await service.upsert(data, itinerario._id);
        if (!res.erro) {
            history.push("/painel/itinerarios");
        } else {
            alert(res.msg);
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="formModule branco itinerariosForm">
            <div className="acoes">
                <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                <button type="button" className="cancelar" onClick={() => history.push('/painel/itinerarios')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
            </div>
            <div className="break"></div>
            
            <div className="field">
                <input className={itinerario.nome ? 'hasText' : ''} name="nome" id="nome" defaultValue={itinerario.nome} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                <label htmlFor="nome">Nome</label>
            </div>
            {/* <div className="field">
                <input className={itinerario.idOld ? 'hasText' : ''} name="idOld" id="idOld" defaultValue={itinerario.idOld} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                <label htmlFor="nome">idOld</label>
            </div> */}
            <div className="break"></div>
            <div className="acoes">
                <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                <button type="button" className="cancelar" onClick={() => history.push('/painel/itinerarios')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
            </div>
        </form>
    )
}

export default ItinerariosForm;